define('controller/step/datetime/BaseWeeklyDateTimeStep',['require','controller/step/datetime/BaseDateTimeStep','Config'],function (require) {

    var BaseDateTimeStep = require('controller/step/datetime/BaseDateTimeStep');
    var Config = require('Config');

    return BaseDateTimeStep.extend({

        _currentDates: {
            from: new Date(),
            to: new Date()
        },


        /**
         * Returns date from to
         *
         * @param Date date
         * @protected
         */
        _getFromToDates: function (date) {
            var from = new Date(date);
            var diff = date.getDay();

            if (Config.getInstance().isMondayFirstDay()) {
                if (diff === 0) {
                    diff = 6;
                } else {
                    diff--;
                }
            }

            from.setDate(from.getDate() - diff);

            var to = new Date(from);
            to.setDate(from.getDate() + 6);

            return {
                'from': from,
                'to': to
            };
        },

        /**
         * Reset current selected date to allow time collection fetch new data
         *
         * @protected
         */
        _resetCurrentDate: function () {
            this._currentDates = {
                from: new Date(),
                to: new Date()
            };
        },
        
        _requiresFetchingTimeCollection: function () {
            if (this._bookingModel.get('start_date')) {
                var dates = this._getFromToDates(Date.parseMysqlDate(
                    this._bookingModel.get('start_date')
                ));
                if (this._currentDates.from.getMysqlDate() === dates.from.getMysqlDate() &&
                    this._currentDates.to.getMysqlDate() === dates.to.getMysqlDate()) {
        
                    return false;
                }
                
                return true;
            } else {
                return true;
            }
        },
        
        _rememberTimeCollectionParams: function () {
            if (this._bookingModel.get('start_date')) {
                var dates = this._getFromToDates(Date.parseMysqlDate(
                    this._bookingModel.get('start_date')
                ));
                
                this._currentDates = dates;
            } else {
                this._resetCurrentDate();
            }
        },

        /**
         * Returns current selected dates
         *
         * @protected
         * @return array
         */
        _getSelectedDates: function () {
            var result = [];
            if (this._bookingModel.get('start_date')) {
                var dates = this._getFromToDates(
                    Date.parseMysqlDate(this._bookingModel.get('start_date'))
                );

                while (dates.from <= dates.to) {
                    result.push(dates.from.getMysqlDate());

                    dates.from.setDate(dates.from.getDate() + 1);
                }
            }

            return result;
        },

        /**
         * Fetches time collection from server
         */
        _fetchTimeCollection: function () {
            if (!this._bookingModel.get('start_date')) {
                this._timeCollection.reset();
                return;
            }
            
            var dates = this._getFromToDates(
                Date.parseMysqlDate(this._bookingModel.get('start_date'))
            );
            
            var prev = this._prevRequest;

            this._prevRequest = this._timeCollection.fetch({
                data: {
                    'from': dates.from.getMysqlDate(),
                    'to': dates.to.getMysqlDate(),
                    'location': this._bookingModel.get('location_id'),
                    'provider': this._bookingModel.get('provider_id'),
                    'service': this._bookingModel.get('service_id'),
                    'products': this._bookingModel.getAddons(),
                    'count': this._bookingModel.get('count'),
                    'booking_id': this._bookingModel.id
                }
            });
            
            if (prev) {
                prev.abort();
            }
        }

    });

});
